import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-admin';
import Menu from '@material-ui/core/Menu';
import CloudDownload from '@material-ui/icons/CloudDownload';

const CleanerMenuTelecharger = ({ children, className, label, ...props }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button className={className} variant="contained" onClick={handleClick}>
        <div
          style={{
            fontSize: '0.8125rem',
            fontWeight: 500,
            fontFamily: 'Roboto',
          }}
        >
          <CloudDownload style={{ fontSize: 0 }} /> 📩 Télécharger
        </div>
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {React.Children.map(children, (child) => {
          if (child) {
            return React.cloneElement(child, {
              ...props,
            });
          }
          return null;
        })}
      </Menu>
    </div>
  );
};

CleanerMenuTelecharger.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  label: PropTypes.string,
};

CleanerMenuTelecharger.defaultProps = {
  children: {},
  className: undefined,
  label: '',
};

export default CleanerMenuTelecharger;
